<app-content-header [title]="'Tableau de bord'"></app-content-header>

@if (showWelcome()) {
  <div class="max-w-2xl mx-auto mt-8 rounded-xl border border-gray-200 bg-white p-5 sm:p-8 shadow-sm text-center mx-2 sm:mx-auto">
    <p class="text-base sm:text-lg text-gray-900 break-words">
      Bonjour <span class="font-semibold">{{ userGreeting().firstName }} {{ userGreeting().lastName }}</span> sur Attestio.
    </p>
    <p class="text-gray-600 mt-3">Veuillez ajouter une entreprise.</p>
    <p class="text-sm text-gray-500 mt-4">Utilisez le bouton dans la barre latérale pour commencer.</p>
  </div>
}
